module.exports = __webpack_public_path__ + "media/images/sample/product-8-7d5a447938662626d49e74417efd65a1.png";